(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-clients-skims"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('simple-client-reviews')) {
    customElements.define('simple-client-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this._events) return;
        this._events = new AbortController();
        const options = { signal: this._events.signal };
        this.addEventListener('change', () => this.filterReviews(), options);
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-ar-open]');
          if (opener) {
            const dialog = this.querySelector('#' + CSS.escape(opener.dataset.arOpen));
            if (dialog && !dialog.open) dialog.showModal();
          }
          if (event.target.closest('[data-ar-close]')) event.target.closest('dialog').close();
          if (event.target instanceof HTMLDialogElement) {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
          }
          if (event.target.closest('[data-ar-next]')) {
            this.querySelector('.ar__gallery')?.scrollBy({ left: 264, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }
          if (event.target.closest('[data-ar-reset]')) this.resetFilters();
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          // Keep gallery media accessible even when its review is filtered out.
          this.append(dialog);
          dialog.addEventListener('close', () => {
            dialog.querySelectorAll('video').forEach(video => video.pause());
          }, options);
        });
        this.addEventListener('shopify:block:select', (event) => {
          this.resetFilters();
          const row = this.querySelector('[data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
          row?.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, options);
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
        this._events?.abort();
        this._events = null;
      }
      resetFilters() {
        const rating = this.querySelector('[data-ar-rating]');
        if (rating) rating.value = 'all';
        this.querySelectorAll('.ar__filters input').forEach(input => input.checked = false);
        this.filterReviews();
      }
      filterReviews() {
        const rating = this.querySelector('[data-ar-rating]')?.value || 'all';
        const media = this.querySelector('[data-ar-media]')?.checked;
        const verified = this.querySelector('[data-ar-verified]')?.checked;
        let visible = 0;
        const rows = this.querySelectorAll('[data-ar-review]');
        rows.forEach(row => {
          const show = (rating === 'all' || row.dataset.rating === rating) && (!media || row.dataset.media === 'true') && (!verified || row.dataset.verified === 'true');
          row.hidden = !show;
          if (show) visible++;
        });
        const empty = this.querySelector('[data-ar-empty]');
        if (empty) empty.hidden = visible > 0 || rows.length === 0;
        const status = this.querySelector('[data-ar-status]');
        if (status) status.textContent = (rating !== 'all' || media || verified) ? visible + ' avis sur ' + rows.length : '';
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
